import React from "react";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

const logos = [
  { name: "Amazon", img: "/images/results/amazon.png" },
  { name: "BCG", img: "/images/results/bcg.png" },
  { name: "Barclays", img: "/images/results/barclays.png" },
  { name: "TikTok", img: "/images/results/TikTok.webp" },
];

const HomeSocialProofBanner: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="py-12 bg-white border-y border-gray-100">
      <div className="max-w-5xl mx-auto px-4">
        <p className="text-center text-xs text-gray-400 mb-8 font-medium tracking-widest uppercase">
          {t("socialProofBanner.label")}
        </p>
        <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12">
          {logos.map((logo, i) => (
            <motion.img
              key={logo.name}
              src={logo.img}
              alt={logo.name}
              className="h-7 md:h-9 object-contain grayscale opacity-50 hover:opacity-80 hover:grayscale-0 transition-all duration-300"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 0.5 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default HomeSocialProofBanner;
